import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { GetPatientResponse } from '../../responses/medical-record/get-patient.response';
import { retry, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EpisodeService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getPatientByEpisode(idEpisode: number): Observable<GetPatientResponse> {
    let uri = `Episode/getPatientEpisode/idEpisode/${idEpisode}`

    return this.httpClient.get<GetPatientResponse>(environment.urlApiMedicalRecord + uri, this.addHeaderToken())
      .pipe(timeout(environment.requestTimeOut), retry(environment.requestRetry), catchError(this.handleError));
  }
}